/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconOffline(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M1.665 15.226a.67.67 0 0 0 .915-.245l7.675-13.292a.67.67 0 1 0-1.161-.67L7.95 3H5a5 5 0 0 0-2.453 9.358L1.42 14.31a.67.67 0 0 0 .245.915zm1.632-4.167A3.5 3.5 0 0 1 5 4.5h2.084l-3.787 6.559zm2.368 4.167a.67.67 0 0 0 .915-.245L7.724 13H11a5 5 0 0 0 2.203-9.49l1.052-1.82a.67.67 0 1 0-1.161-.671L5.42 14.311a.67.67 0 0 0 .245.915zM12.45 4.814A3.501 3.501 0 0 1 11 11.5H8.59l3.86-6.686z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M14.86 1.589a1 1 0 0 1 .366 1.366L4.204 22.045a1 1 0 1 1-1.732-1l1.74-3.013A7 7 0 0 1 7.764 5h3.97l1.758-3.045a1 1 0 0 1 1.367-.366zm-4.28 5.41H7.766A5 5 0 0 0 5.21 16.3L10.58 7zm10.582-5.41a1 1 0 0 1 .366 1.366l-1.74 3.013A7 7 0 0 1 16.236 19h-3.97l-1.758 3.045a1 1 0 1 1-1.733-1l11.022-19.09a1 1 0 0 1 1.366-.366zm-7.743 15.41h2.816a5 5 0 0 0 2.554-9.3l-5.37 9.3z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconOffline is deprecated and will be archived soon. Use IconOffline instead.
 */
export function Experimental__IconOffline(props) {
  return /*#__PURE__*/React.createElement(IconOffline, props);
}